import { BootstrapLayout } from "@rpforms/shared/build/components/BootstrapLayout";
import { SchemaBuilder } from "@rpforms/shared/build/spec/SchemaBuilder";
import React from "react";
import { DataPresenter } from "../DataPresenter";

const ViewEntry = ({ entry }: any) => {
    const schemaBuilder = new SchemaBuilder();
    const rawFormData = entry.latest_revision?.form_data || entry.form_revision?.form_data;
    const formData =
        typeof rawFormData === "string" ? JSON.parse(rawFormData || "{}") : rawFormData || {};
    schemaBuilder.use(formData);
    return (
        <>
            <DataPresenter
                form={entry.form}
                schema={schemaBuilder}
                layout={BootstrapLayout}
                saveState={entry.form_data}
            />
        </>
    );
};

export default ViewEntry;
